import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const MicrosoftTeamsIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				d="M9.143 6.286h5.07c.356 0 .644.288.644.644v3.193a2.147 2.147 0 0 1-2.146 2.147c-.306 0-.594-.067-.855-.183A3.144 3.144 0 0 1 5.833 12H1.81a.67.67 0 0 1-.667-.667V4.667c0-.367.3-.667.667-.667h5.44a1.893 1.893 0 1 1 1.893 1.893zm0-3.608c-.73 0-1.322.593-1.322 1.322h.655c.367 0 .667.3.667.667v.655c.729 0 1.322-.593 1.322-1.322s-.593-1.322-1.322-1.322m-4.587 7.75h1.182v-3.67h1.365V5.572h-3.92V6.76h1.373zm9.73-.305V6.93a.073.073 0 0 0-.073-.073h-2.217l.004.069v4.217q0 .188-.021.369c.218.118.466.187.732.187.868 0 1.575-.707 1.575-1.576m-5.429 3.591a2.575 2.575 0 0 0 2.572-2.571V6.926a.07.07 0 0 0-.069-.069H9.143v4.476c0 .367-.3.667-.667.667H6.433a2.58 2.58 0 0 0 2.424 1.714m4-10.285a.858.858 0 0 0 0 1.714.858.858 0 0 0 0-1.714m1.429.857a1.428 1.428 0 1 1-2.857 0 1.428 1.428 0 0 1 2.857 0"
			></path>
		</svg>
	),
)
